export default __webpack_public_path__ + "static/media/altaclub_logo.5b874c3f.svg";